import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationUpdateArgs } from "types/generated";

export const UPDATE_AI_INTEGRATION: TypedDocumentNode<
  {
    aiIntegrationUpdate: Pick<AiIntegration, "id">;
  },
  MutationAiIntegrationUpdateArgs
> = gql`
  mutation UpdateAiIntegration(
    $id: ID!
    $name: String!
    $description: String
    $labels: [String!]!
    $provider: String!
    $apiKey: String
    $providerIntegrationId: ID
    $providerConfig: AIProviderConfigInput
    $baseURL: String
    $models: [String!]
    $space: ID
  ) {
    aiIntegrationUpdate(
      id: $id
      name: $name
      description: $description
      labels: $labels
      provider: $provider
      apiKey: $apiKey
      providerIntegrationId: $providerIntegrationId
      providerConfig: $providerConfig
      baseURL: $baseURL
      models: $models
      space: $space
    ) {
      id
    }
  }
`;
